module.exports = __webpack_public_path__ + "static/banner-tablet-830cdc41b3b1de3acf99edc18ed64097.png";